// extracted by mini-css-extract-plugin
export default {"host":"Cell_host__RWZ6D"};